import { useSelector } from 'react-redux';

export default (type = '') => {
  if (!type) return {};
  return useSelector(state => state[type], [type]);
};
